import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import amountFormat from "../../utils/amountFormat.js";
import {
    getPartnerIsRefreshApiKeyLoadingSelector,
    getPartnerParams,
    getPartnerPostbacksCommonSelector
} from "./partnerSelectors";
import CopyReferralLink from "./components/CopyReferralLink/CopyReferralLink";
import { useCallback, useMemo } from "react";
import {formReferralLink} from "./partnerUtils";
import PartnerPostbacks from "./PartnerPostbacks/PartnerPostbacks";
import { Button } from "react-bootstrap";
import { refreshApiKeyAction } from "./partnerActions";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

function Partner(props) {
    const {
        isRefreshApiKeyLoading,
        partnerParams,
        postbacksList,
        refreshApiKeyAction,
    } = props;
    const {getLangPath} = useLangContext();
    const referralLink = useMemo(() => formReferralLink({
        refshare: partnerParams.refshare,
    }), [partnerParams.refshare]);

    const handleRefreshApiKeyButtonClick = useCallback(() => {
        const isConfirmed = window.confirm(getLangPath('partner.profile.refresh_api_key_confirm'));
        if (isConfirmed) {
            refreshApiKeyAction();
        }
    }, [getLangPath, refreshApiKeyAction]);

    return <div className="pb-5">
        <span className={'text-secondary'}>{getLangPath('partner.profile.referral_link')}</span>
        <div className="d-flex align-items-center mb-2">
            <h4 className="mb-0 me-3">{referralLink}</h4>
            <CopyReferralLink referralLink={referralLink}/>
        </div>
        <span className={'text-secondary'}>{getLangPath('partner.profile.partner_balance')}</span>
        <h4>${amountFormat(partnerParams.balance)}</h4>
        <span className="text-secondary">{getLangPath('partner.partner_id')}</span>
        <h4>{partnerParams.refshare}</h4>
        <span className="text-secondary">{getLangPath('partner.api_key')}</span>
        <h6>{partnerParams.api_key}</h6>
        <Button
                disabled={isRefreshApiKeyLoading}
                onClick={handleRefreshApiKeyButtonClick}
                variant="info"
                size="sm"
        >
            {getLangPath('partner.profile.refresh_api_key_button')}
        </Button>
        <p className="text-secondary mt-3">{getLangPath('partner.postbacks.title')}</p>
        <PartnerPostbacks postbacksList={postbacksList}/>
    </div>
}

const mapStateToProps = createStructuredSelector({
    isRefreshApiKeyLoading: getPartnerIsRefreshApiKeyLoadingSelector,
    postbacksList: getPartnerPostbacksCommonSelector,
    partnerParams: getPartnerParams
});

const mapDispatchToProps = {
    refreshApiKeyAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Partner);
